// Wallet Backgrounds
import metamask from "../images/howtobuy/metamask.jpeg"
import walletBg from "../images/howtobuy/walletBg.png"
import noWalletBg from "../images/howtobuy/noWalletBg.png"

import nowallet1 from "../images/howtobuy/nowallet1.jpeg"
import nowallet2 from "../images/howtobuy/nowallet2.jpeg"
import nowallet3 from "../images/howtobuy/nowallet3.jpeg"
import nowallet4 from "../images/howtobuy/nowallet4.jpeg"

import metamask1 from "../images/howtobuy/metamask1.jpeg"
import metamask2 from "../images/howtobuy/metamask2.jpeg"
import metamask3 from "../images/howtobuy/metamask3.jpeg"
import metamask4 from "../images/howtobuy/metamask4.jpeg"
import metamask5 from "../images/howtobuy/metamask5.jpeg"

import twallet1 from "../images/howtobuy/twallet1.jpeg"
import twallet2 from "../images/howtobuy/twallet2.jpeg"
import twallet3 from "../images/howtobuy/twallet3.jpeg"
import twallet4 from "../images/howtobuy/twallet4.jpeg"
import twallet5 from "../images/howtobuy/twallet5.jpeg"


export const wallets = [
    {
      name: "Metamask",
      heading: "BUY SUPC USING METAMASK",
      subheading: "Metamask is the leading self-custodial wallet. The safe and simple way to access blockchain applications and web3.",
      image: metamask,
      topics: [
        {
          topic: "HOW TO BUY SUPC USING ETH (METAMASK)",
          content: ` <div style="list-style: inside">
                  <p>
                    <b>Step 1: Prepare Your Wallet:</b> Ensure you have some extra Ethereum
                    (ETH) in your wallet to cover the transaction and gas fees. We recommend
                    having at least $20 worth of ETH.
                  </p>
            
                  <p>
                    <b>Step 2: Access Supchain Website: </b>Open your web browser and go to
                    <u>Supchain.io</u>. The website should display the Supchain platform.
                  </p>
            
                  <div>
                    <p><b>Step 3: Connect Your Wallet:</b></p>
                    <ul>
                      <li>
                        Click the "Connect" button located at the top-right corner of the
                        screen.
                      </li>
                      <li>Select "MetaMask" from the options that appear.</li>
                      <li>
                        A MetaMask pop-up will appear, prompting you to choose your wallet
                        if you have multiple.
                      </li>
                      <li>
                        Select your preferred wallet and click "Next," then "Connect."
                      </li>
                      <li>Your wallet is now connected to the Supchain platform.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 4: Access Purchase Options:</b></p>
                    <ul>
                      <li>
                        You will now see four new buttons, and your wallet status will be
                        displayed at the top-right corner of the screen.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: MetaMask Troubleshooting (if needed): </b></p>
                    <ul>
                      <li>
                        If you don't receive a MetaMask pop-up when trying to connect your
                        wallet, click the MetaMask icon at the top-right corner of the
                        screen and enter your MetaMask password.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Purchase SUPL Tokens with ETH: </b></p>
                    <ul>
                      <li>Click the "Buy SUPC with ETH" button on the platform.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 7: Choose Purchase Amount: </b></p>
                    <ul>
                      <li>Select the amount of ETH you want to spend.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 8: Confirm Your Purchase: </b></p>
                    <ul>
                      <li>Click the "Buy Now" button.</li>
                      <li>
                        A MetaMask pop-up will appear displaying the transaction details.
                      </li>
                      <li>Click "Confirm" to proceed with the purchase.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Confirm Gas Fee:</b></p>
                    <ul>
                      <li>
                        The transaction will process, and there may be a step where you need
                        to confirm the gas fee.
                      </li>
                      <li>Click "Confirm" to complete the transaction.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 10: Transaction Confirmation: </b></p>
                    <ul>
                      <li>
                        After confirming, you will see a confirmation message showing the
                        details of your purchase.
                      </li>
                      <li>Click "Confirm" to complete the transaction.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p>
                      <b>Step 11: View Transaction: </b>If you wish to review your
                      transaction on Etherscan, you can click the "View Transaction on
                      Etherscan" button provided.
                    </p>
                    <p>
                      That's it! You've successfully purchased SUPC tokens using Ethereum on
                      the Supchain platform. Please make sure to keep an eye on your
                      contributions, and if you encounter any issues, refer to the
                      troubleshooting page on the platform or contact their support for
                      assistance.
                    </p>
                  </div>
                </div>`,
          image: metamask1
        },
        {
          topic: "HOW TO BUY SUPC USING USDT ON ETH (METAMASK)",
          content: `<div style="list-style: inside">
                  <div>
                    <p><b>Step 1: Preparation:</b></p>
                    <ul>
                      <li>
                        Make sure you have at least 0.015 ETH in your wallet to cover the
                        gas fee.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 2: Access Supchain Website: </b></p>
                    <ul>
                      <li>
                        Open your web browser and go to <u>Supchain.io</u>. The website
                        should display the Supchain platform.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Connect Your Wallet:</b></p>
                    <ul>
                      <li>
                        Click the "Connect" button located at the top-right corner of the
                        screen.
                      </li>
                      <li>Select "Metamask" and choose your wallet.</li>
                      <li>Click "Next" and then "Connect."</li>
                      <li>
                        You are now connected, as indicated at the top-right corner. If you
                        don't see the Metamask notification, click the Metamask icon in the
                        top-right corner and enter your password.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 4: Access Purchase Options: </b></p>
                    <ul>
                      <li>You will see four new buttons on the screen.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: Initiate Purchase:</b></p>
                    <ul>
                      <li>Click "Buy Supc with USDT."</li>
                      <li>
                        Ensure you have sufficient USDT in your wallet to cover the
                        purchase.
                      </li>
                      <li>
                        If you have enough USDT and ETH for the gas fee, proceed; otherwise,
                        you'll receive a warning.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Select Purchase Amount:</b></p>
                    <ul>
                      <li>
                        You can choose to spend the maximum amount of USDT by clicking
                        "Max."
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 7: Confirm the Transaction: </b></p>
                    <ul>
                      <li>A Metamask pop-up will appear.</li>
                      <li>Click "Confirm" to proceed with the transaction.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 8: Transaction Confirmation:</b></p>
                    <ul>
                      <li>
                        You will receive a notification confirming that your purchase was
                        successful.
                      </li>
                      <li>
                        The transaction details can be viewed on Etherscan by clicking "View
                        Transaction." .
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Completion: </b></p>
                    <ul>
                      <li>
                        Congratulations! You've successfully purchased SUPC tokens using USDT
                        on the ERC20 network.
                      </li>
                      <li>
                        Your tokens will be available for claiming after the presale period
                        ends.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 10: Further Assistance: </b></p>
                    <ul>
                      <li>
                        If you encounter any issues or have concerns, refer to the
                        troubleshooting page on the platform.
                      </li>
                      <li>
                        You can also join the Telegram or Discord communities to get
                        additional assistance from moderators.
                      </li>
                    </ul>
                  </div>
            
                  <p>
                    That's it! You've completed the process of buying SUPC tokens using USDT
                    on the ERC20 network. Please be cautious and do your research when
                    contributing to cryptocurrencies.
                  </p>
                </div>`,
          image: metamask2
        },
        {
          topic: "HOW TO BUY SUPC USING BNB (METAMASK)",
          content: `  <div style="list-style: inside">
                  <div>
                    <p><b>Step 1: Access Supchain Website:</b></p>
                    <ul>
                      <li>Open your web browser and navigate to Supchain.io.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 2: Connect Your Wallet:</b></p>
                    <ul>
                      <li>
                        Click the "Connect" button located at the top-right corner of the
                        screen.
                      </li>
                      <li>
                        Pop-up box will appear and the option to connect wallet will appear,
                        click on “Wallet Connect” to enable connecting your Trust Wallet
                      </li>
                      <li>
                        QR code will appear on the screen to connect through your Trust
                        Wallet app that is on your phone by scan the QR code.
                      </li>
                      <li>You are now connected, as indicated at the top-right corner.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Switch to BNB Smart Chain:</b></p>
                    <ul>
                      <li>
                        Scroll down to the bottom of the page, where you'll find an option
                        to switch networks.
                      </li>
                      <li>
                        Follow the prompts to switch to the BNB Smart Chain using Metamask.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 4: Access BNB Purchase Option:</b></p>
                    <ul>
                      <li>
                        Once connected to the BNB Smart Chain, click the "Buy Supc with BNB"
                        button.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: Select Purchase Amount:</b></p>
                    <ul>
                      <li>Choose the amount of BNB you want to spend.</li>
                      <li>
                        Note the purchase bonuses based on the amount you spend, with a
                        maximum bonus of 25% for purchases over $50,000.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Confirm Purchase:</b></p>
                    <ul>
                      <li>Once you've made your selections, click "Buy Now."</li>
                      <li>A Metamask pop-up will appear with transaction details.</li>
                      <li>Click "Confirm" to complete the purchase.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 7: Transaction Confirmation: </b></p>
                    <ul>
                      <li>
                        After confirming, you will receive a notification from Metamask
                        confirming the transaction.
                      </li>
                      <li>
                        You can also click the "View Transaction" button to access
                        transaction details on the blockchain.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 8: Completion:</b></p>
                    <ul>
                      <li>
                        Congratulations! You've successfully purchased SUPC tokens with BNB
                        on the BNB Smart Chain.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Additional Support:</b></p>
                    <ul>
                      <li>
                        If you have questions or encounter any issues, consider joining the
                        Discord or Telegram communities to receive extra information and
                        assistance from moderators.
                      </li>
                    </ul>
                  </div>
            
                  <p>
                    That's it! You've completed the process of buying SUPC tokens using BNB
                    on the BNB Smart Chain. Always be vigilant and do your due diligence
                    when contributing to cryptocurrencies.
                  </p>
                </div>`,
          image: metamask3
        },
        {
          topic: "HOW TO BUY SUPC USING USDT ON BSC (METAMASK)",
          content: `    <div style="list-style: inside">
                  <div>
                    <p><b>Step 1: Preparation:</b></p>
                    <ul>
                      <li>
                        Make sure you have at least 0.015 ETH in your wallet to cover the
                        gas fee.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 2: Access Supchain Website: </b></p>
                    <ul>
                      <li>
                        Open your web browser and go to Supchain.io. The website should
                        display the Supchain platform.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Connect Your Wallet: </b></p>
                    <ul>
                      <li>
                        Click the "Connect" button located at the top-right corner of the
                        screen.
                      </li>
                      <li>Select "Metamask" and choose your wallet.</li>
                      <li>Click "Next" and then "Connect."</li>
                      <li>
                        You are now connected, as indicated at the top-right corner. If you
                        don't see the Metamask notification, click the Metamask icon in the
                        top-right corner and enter your password.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 4: Access Purchase Options:</b></p>
                    <ul>
                      <li>You will see four new buttons on the screen.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: Initiate Purchase: </b></p>
                    <ul>
                      <li>Click "Buy Supc with USDT."</li>
                      <li>
                        Ensure you have sufficient USDT in your wallet to cover the
                        purchase.
                      </li>
                      <li>
                        If you have enough USDT and ETH for the gas fee, proceed; otherwise,
                        you'll receive a warning.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Select Purchase Amount:</b></p>
                    <ul>
                      <li>
                        You can choose to spend the maximum amount of USDT by clicking
                        "Max."
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 7:Confirm the Transaction: </b></p>
                    <ul>
                      <li>A Metamask pop-up will appear.</li>
                      <li>Click "Confirm" to proceed with the transaction.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 8: Transaction Confirmation: </b></p>
                    <ul>
                      <li>
                        You will receive a notification confirming that your purchase was
                        successful.
                      </li>
                      <li>
                        The transaction details can be viewed on Etherscan by clicking "View
                        Transaction."
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Completion:</b></p>
                    <ul>
                      <li>
                        Congratulations! You've successfully purchased SUPC tokens using USDT
                        on the ERC20 network.
                      </li>
                      <li>
                        Your tokens will be available for claiming after the presale period
                        ends.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 10: Further Assistance: </b></p>
                    <ul>
                      <li>
                        If you encounter any issues or have concerns, refer to the troubleshooting page on the platform.
                      </li>
                      <li>
                        You can also join the Telegram or Discord communities to get additional assistance from moderators.
                      </li>
                    </ul>
                  </div>
            
                  <p>
                    That's it! You've completed the process of buying SUPC tokens using USDT on the ERC20 network. Please be cautious and do your research when contributing to cryptocurrencies.
                  </p>
                </div>`,
          image: metamask4
        },
        {
          topic: "HOW TO BUY SUPC USING CREDIT CARD",
          content: ` <div style="list-style: inside">
                  <div>
                    <p><b>Step 1: Access Supchain Website:</b></p>
                    <ul>
                      <li>Open your web browser and visit Supchain.io.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 2: Click the "Connect" Button:</b></p>
                    <ul>
                      <li>
                        Locate and click the "Connect" button on the website's interface.
                        You'll typically find this button at the top-right corner of the
                        screen.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Choose "Wallet Connect": </b></p>
                    <ul>
                      <li>
                        After clicking "Connect," a pop-up box will appear with various
                        wallet connection options. Look for and select "Wallet Connect"
                        among the options.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 4: Scan the QR Code:</b></p>
                    <ul>
                      <li>
                        A QR code will be displayed on the website's screen. To connect your
                        Trust Wallet, open the Trust Wallet app on your mobile phone.
                      </li>
                      <li>
                        Within the Trust Wallet app, look for the "Wallet Connect" feature.
                        It's usually found in the settings or options menu.
                      </li>
                      <li>
                        Use the Trust Wallet app to scan the QR code displayed on the
                        website's screen. This action establishes a secure connection
                        between your Trust Wallet and the website.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: Connection Confirmation:</b></p>
                    <ul>
                      <li>
                        Once you've successfully scanned the QR code, you'll notice that you
                        are now connected. This connection status is often indicated at the
                        top-right corner of the website's interface
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Select Purchase Option:</b></p>
                    <ul>
                      <li>
                        After connecting your wallet, you'll notice new buttons have
                        appeared.
                      </li>
                      <li>
                        Click "Buy SUPC with Card" to proceed with your credit card purchase.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 7: Choose Purchase Amount:</b></p>
                    <ul>
                      <li>Decide how much SUPC you want to buy using your credit card.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Confirm and Proceed:</b></p>
                    <ul>
                      <li>
                        A new window will pop up, prompting you to enter your phone number
                        for security purposes.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 10: Enter Credit Card Details:</b></p>
                    <ul>
                      <li>Fill in your credit card details as required.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 11: Billing Information: </b></p>
                    <ul>
                      <li>
                        You'll be prompted to enter your billing details. Ensure accuracy.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 12: Transaction Confirmation: </b></p>
                    <ul>
                      <li>
                        Once the transaction is complete, you'll receive a confirmation email.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 13: Completion:</b></p>
                    <ul>
                      <li>
                        Congratulations! You've successfully purchased SUPC tokens using your credit card.
                      </li>
                      <li>
                        Your tokens will be available for claiming or use as per the platform's instructions.
                      </li>
                    </ul>
                  </div>
                  
                  <div>
                    <p><b>Additional Support:</b></p>
                    <ul>
                      <li>
                        If you have any questions or encounter issues, consider reaching out to the Supchain community on Discord or Telegram for additional information and assistance from moderators.
                      </li>
                    </ul>
                  </div>
            
                </div>`,
          image: metamask5
        },
      ]
  
    },
    {
      name: "Trust Wallet",
      heading: "BUY SUPC USING TRUSTWALLET",
      subheading: "Metamask is the leading self-custodial wallet—the safe and simple way to access blockchain applications and web3.",
      image: walletBg,
      topics: [
        {
          topic: "How to buy SUPC using ETH (Trustwallet)",
          content: `<div style="list-style: inside">
                  <div>
                    <p><b>Step 1: Access Supellecoin Website:</b></p>
                    <ul>
                      <li>Open your web browser and visit Supelle.io.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 2: Click the "Connect" Button:</b></p>
                    <ul>
                      <li>
                        Locate and click the "Connect" button on the website's interface.
                        You'll typically find this button at the top-right corner of the
                        screen.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Choose "Wallet Connect": </b></p>
                    <ul>
                      <li>
                        After clicking "Connect," a pop-up box will appear with various
                        wallet connection options. Look for and select "Wallet Connect"
                        among the options.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 4: Scan the QR Code:</b></p>
                    <ul>
                      <li>
                        A QR code will be displayed on the website's screen. To connect your
                        Trust Wallet, open the Trust Wallet app on your mobile phone.
                      </li>
                      <li>
                        Within the Trust Wallet app, look for the "Wallet Connect" feature.
                        It's usually found in the settings or options menu.
                      </li>
                      <li>
                        Use the Trust Wallet app to scan the QR code displayed on the
                        website's screen. This action establishes a secure connection
                        between your Trust Wallet and the website.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: Connection Confirmation:</b></p>
                    <ul>
                      <li>
                        Once you've successfully scanned the QR code, you'll notice that you
                        are now connected. This connection status is often indicated at the
                        top-right corner of the website's interface
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Select Purchase Option:</b></p>
                    <ul>
                      <li>You will want to switch to BNB by clicking on “Buy with BNB”</li>
                      <li>
                        Once connected to the BNB Smart Chain, click the "Buy Supc with ETH"
                        button.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 7: Initiate Purchase: </b></p>
                    <ul>
                      <li>
                        Ensure you have sufficient USDT in your wallet to cover the
                        purchase.
                      </li>
                      <li>
                        If you have enough USDT and ETH for the gas fee, proceed; otherwise,
                        you'll receive a warning.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 8: Choose Purchase Amount:</b></p>
                    <ul>
                      <li>Select the amount of ETH you want to spend.</li>
                      <li>Click the "Buy Now" button.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Transaction Confirmation:</b></p>
                    <ul>
                      <li>
                        After confirming, you will see a confirmation message showing the
                        details of your purchase.
                      </li>
                    </ul>
                  </div>
                </div>`,
          image: twallet1
        },
        {
          topic: "How to buy SUPC using USDT on ETH (Trustwallet)",
          content: ` <div style="list-style: inside">
                  <div>
                    <p><b>Step 1: Preparation:</b></p>
                    <ul>
                      <li>
                        Make sure you have at least 0.015 ETH in your wallet to cover the
                        gas fee. Or about $20 worth of ETH
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 2: Access Supchain Website:</b></p>
                    <ul>
                      <li>
                        Open your web browser and go to Supchain.io. The website should
                        display the Supchain platform.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Click the "Connect" Button:</b></p>
                    <ul>
                      <li>
                        Locate and click the "Connect" button on the website's interface.
                        You'll typically find this button at the top-right corner of the
                        screen.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 4: Choose "Wallet Connect": </b></p>
                    <ul>
                      <li>
                        After clicking "Connect," a pop-up box will appear with various
                        wallet connection options. Look for and select "Wallet Connect"
                        among the options.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: Scan the QR Code:</b></p>
                    <ul>
                      <li>
                        A QR code will be displayed on the website's screen. To connect your
                        Trust Wallet, open the Trust Wallet app on your mobile phone.
                      </li>
                      <li>
                        Within the Trust Wallet app, look for the "Wallet Connect" feature.
                        It's usually found in the settings or options menu.
                      </li>
                      <li>
                        Use the Trust Wallet app to scan the QR code displayed on the
                        website's screen. This action establishes a secure connection
                        between your Trust Wallet and the website.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Connection Confirmation:</b></p>
                    <ul>
                      <li>
                        Once you've successfully scanned the QR code, you'll notice that you
                        are now connected. This connection status is often indicated at the
                        top-right corner of the website's interface
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 7: Select Purchase Option:</b></p>
                    <ul>
                      <li>You will want to switch to BNB by clicking on “Buy with BNB”</li>
                      <li>
                        Once connected to the BNB Smart Chain, click the "Buy Supc with ETH"
                        button.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 8: Initiate Purchase: </b></p>
                    <ul>
                      <li>Click "Buy Supc with USDT."</li>
                      <li>
                        Ensure you have sufficient USDT in your wallet to cover the
                        purchase.
                      </li>
                      <li>
                        If you have enough USDT and ETH for the gas fee, proceed; otherwise,
                        you'll receive a warning.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Choose Purchase Amount:</b></p>
                    <ul>
                      <li>
                        You can choose to spend the maximum amount of USDT by clicking
                        "Max."
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 10: Confirm Purchase:</b></p>
                    <ul>
                      <li>Once you've made your selections, click "Buy Now."</li>
                      <li>
                        On your trust wallet app, you should get a notification asking if
                        you want to “Confirm Your Payment”
                      </li>
                      <li>Click "Approve" to complete the purchase on Trust Wallet app</li>
                      <li>
                        Note: You may get a warning message “if you are using your trust
                        wallet through a Binance Smart Chain and that it is a high risk, be
                        careful and make sure you trust this site” that is normal. Just make
                        sure you are on Supelle.io
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 11: Completion:</b></p>
                    <ul>
                      <li>
                        Congratulations! You've successfully purchased SUPC tokens using USDT
                        on the ERC20 network.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 12: Further Assistance:</b></p>
                    <ul>
                      <li>
                        If you encounter any issues or have concerns, refer to the
                        troubleshooting page on the platform.
                      </li>
                      <li>
                        You can also join the Telegram or Discord communities to get additional assistance from moderators.
                      </li>
                    </ul>
                  </div>
            
                  <p>
                    That's it! You've completed the process of buying SUPC tokens using USDT on the ERC20 network. Please be cautious and do your research when contributing to cryptocurrencies.
                  </p>
                </div>`,
          image: twallet2
        },
        {
          topic: "How to buy SUPC using BNB (Trustwallet)",
          content: `<div style="list-style: inside">
  
                  <div>
                    <p><b>Step 1: Access Supchain Website:</b></p>
                    <ul>
                      <li>
                        Open your web browser and go to Supchain.io.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 2: Click the "Connect" Button:</b></p>
                    <ul>
                      <li>
                        Locate and click the "Connect" button on the website's interface.
                        You'll typically find this button at the top-right corner of the
                        screen.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Choose "Wallet Connect": </b></p>
                    <ul>
                      <li>
                        After clicking "Connect," a pop-up box will appear with various
                        wallet connection options. Look for and select "Wallet Connect"
                        among the options.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 4: Scan the QR Code:</b></p>
                    <ul>
                      <li>
                        A QR code will be displayed on the website's screen. To connect your
                        Trust Wallet, open the Trust Wallet app on your mobile phone.
                      </li>
                      <li>
                        Within the Trust Wallet app, look for the "Wallet Connect" feature.
                        It's usually found in the settings or options menu.
                      </li>
                      <li>
                        Use the Trust Wallet app to scan the QR code displayed on the
                        website's screen. This action establishes a secure connection
                        between your Trust Wallet and the website.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: Connection Confirmation:</b></p>
                    <ul>
                      <li>
                        Once you've successfully scanned the QR code, you'll notice that you
                        are now connected. This connection status is often indicated at the
                        top-right corner of the website's interface
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Select Purchase Option:</b></p>
                    <ul>
                      <li>You will want to switch to BNB by clicking on “Buy Supl with BNB”</li>
                      <li>
                        Once connected to the BNB Smart Chain, click the "Buy Supl with ETH"
                        button.
                      </li>
                    </ul>
                  </div>
            
            
                  <div>
                    <p><b>Step 7: Choose Purchase Amount:</b></p>
                    <ul>
                      <li>
                        Choose the amount of BNB you want to spend.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 8: Confirm Purchase:</b></p>
                    <ul>
                      <li>Once you've made your selections, click "Buy Now."</li>
                      <li>
                        On your trust wallet app, you should get a notification asking if
                        you want to “Confirm Your Payment”
                      </li>
                      <li>Click "Approve" to complete the purchase on Trust Wallet app</li>
                      <li>
                        Note: You may get a warning message “if you are using your trust
                        wallet through a Binance Smart Chain and that it is a high risk, be
                        careful and make sure you trust this site” that is normal. Just make
                        sure you are on Supchain.io
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Completion:</b></p>
                    <ul>
                      <li>
                        Congratulations! You've successfully purchased SUPC tokens with BNB on the BNB Smart Chain.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 10: Additional Support:</b></p>
                    <ul>
                      <li>
                        If you have questions or encounter any issues, consider joining the Discord or Telegram communities to receive extra information and assistance from moderators.
                      </li>
                    </ul>
                  </div>
            
                  <p>
                    That's it! You've completed the process of buying SUPC tokens using BNB on the BNB Smart Chain. Always be vigilant and do your due diligence when contributing to cryptocurrencies.
                  </p>
                </div>`,
          image: twallet3
        },
        {
          topic: "How to buy SUPC using USDT on BSC (Trustwallet)",
          content: ` <div style="list-style: inside">
                  <div>
                    <p><b>Step 1: Preparation:</b></p>
                    <ul>
                      <li>
                        Make sure you have at least 0.015 ETH in your wallet to cover the
                        gas fee.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 2: Access Supchain Website:</b></p>
                    <ul>
                      <li>
                        Open your web browser and go to Supchain.io. The website should
                        display the Supchain platform.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Click the "Connect" Button:</b></p>
                    <ul>
                      <li>
                        Locate and click the "Connect" button on the website's interface.
                        You'll typically find this button at the top-right corner of the
                        screen.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 4: Choose "Wallet Connect": </b></p>
                    <ul>
                      <li>
                        After clicking "Connect," a pop-up box will appear with various
                        wallet connection options. Look for and select "Wallet Connect"
                        among the options.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: Scan the QR Code:</b></p>
                    <ul>
                      <li>
                        A QR code will be displayed on the website's screen. To connect your
                        Trust Wallet, open the Trust Wallet app on your mobile phone.
                      </li>
                      <li>
                        Within the Trust Wallet app, look for the "Wallet Connect" feature.
                        It's usually found in the settings or options menu.
                      </li>
                      <li>
                        Use the Trust Wallet app to scan the QR code displayed on the
                        website's screen. This action establishes a secure connection
                        between your Trust Wallet and the website.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Connection Confirmation:</b></p>
                    <ul>
                      <li>
                        Once you've successfully scanned the QR code, you'll notice that you
                        are now connected. This connection status is often indicated at the
                        top-right corner of the website's interface
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 7: Select Purchase Option:</b></p>
                    <ul>
                      <li>You will want to switch to BNB by clicking on “Buy with BNB”</li>
                      <li>
                        Once connected to the BNB Smart Chain, click the "Buy Supc with ETH"
                        button.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 8: Initiate Purchase:</b></p>
                    <ul>
                      <li>
                        Ensure you have sufficient USDT in your wallet to cover the
                        purchase.
                      </li>
                      <li>
                        If you have enough USDT and ETH for the gas fee, proceed; otherwise,
                        you'll receive a warning.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Confirm Purchase:</b></p>
                    <ul>
                      <li>Once you've made your selections, click "Buy Now."</li>
                      <li>
                        On your trust wallet app, you should get a notification asking if
                        you want to “Confirm Your Payment”
                      </li>
                      <li>Click "Approve" to complete the purchase on Trust Wallet app</li>
                      <li>
                        Note: You may get a warning message “if you are using your trust
                        wallet through a Binance Smart Chain and that it is a high risk, be
                        careful and make sure you trust this site” that is normal. Just make
                        sure you are on Supchain.io
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 10: Transaction Confirmation:</b></p>
                    <ul>
                      <li>
                        You will receive a notification confirming that your purchase was
                        successful.
                      </li>
                      <li>
                        The transaction details can be viewed on Etherscan by clicking "View
                        Transaction."
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 11: Completion: </b></p>
                    <ul>
                      <li>
                        Congratulations! You've successfully purchased SUPC tokens using USDT
                        on the ERC20 network.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 12: Further Assistance: </b></p>
                    <ul>
                      <li>
                        If you encounter any issues or have concerns, refer to the
                        troubleshooting page on the platform.
                      </li>
                      <li>
                        You can also join the Telegram or Discord communities to get
                        additional assistance from moderators.
                      </li>
                    </ul>
                  </div>
            
                  <p>
                    That's it! You've completed the process of buying SUPC tokens using USDT
                    on the ERC20 network. Please be cautious and do your research when
                    contributing to cryptocurrencies.
                  </p>
                </div>`,
          image: twallet4
        },
        {
          topic: "How to buy SUPC using CREDIT CARD",
          content: ` <div style="list-style: inside">
                  <div>
                    <p><b>Step 1: Access Supchain Website:</b></p>
                    <ul>
                      <li>Open your web browser and go to Supchain.io.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 2: Click the "Connect" Button:</b></p>
                    <ul>
                      <li>
                        Locate and click the "Connect" button on the website's interface.
                        You'll typically find this button at the top-right corner of the
                        screen.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Choose "Wallet Connect": </b></p>
                    <ul>
                      <li>
                        After clicking "Connect," a pop-up box will appear with various
                        wallet connection options. Look for and select "Wallet Connect"
                        among the options.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 4: Scan the QR Code:</b></p>
                    <ul>
                      <li>
                        A QR code will be displayed on the website's screen. To connect your
                        Trust Wallet, open the Trust Wallet app on your mobile phone.
                      </li>
                      <li>
                        Within the Trust Wallet app, look for the "Wallet Connect" feature.
                        It's usually found in the settings or options menu.
                      </li>
                      <li>
                        Use the Trust Wallet app to scan the QR code displayed on the
                        website's screen. This action establishes a secure connection
                        between your Trust Wallet and the website.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: Connection Confirmation:</b></p>
                    <ul>
                      <li>
                        Once you've successfully scanned the QR code, you'll notice that you
                        are now connected. This connection status is often indicated at the
                        top-right corner of the website's interface
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Select Purchase Option:</b></p>
                    <ul>
                      <li>
                        After connecting your wallet, you'll notice new buttons have
                        appeared.
                      </li>
                      <li>
                        Click "Buy SUPC with Card" to proceed with your credit card purchase.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 7: Choose Purchase Amount: </b></p>
                    <ul>
                      <li>Decide how much SUPC you want to buy using your credit card.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Confirm and Proceed:</b></p>
                    <ul>
                      <li>
                        A new window will pop up, prompting you to enter your phone number
                        for security purposes.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 10: Enter Credit Card Details:</b></p>
                    <ul>
                      <li>Fill in your credit card details as required.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 11: Billing Information: </b></p>
                    <ul>
                      <li>
                        You'll be prompted to enter your billing details. Ensure accuracy.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 12: Transaction Confirmation:</b></p>
                    <ul>
                      <li>
                        Once the transaction is complete, you'll receive a confirmation
                        email.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 13: Completion: </b></p>
                    <ul>
                      <li>
                        Congratulations! You've successfully purchased SUPC tokens using your
                        credit card.
                      </li>
                      <li>
                        Your tokens will be available for claiming or use as per the
                        platform's instructions.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Additional Support: </b></p>
                    <ul>
                      <li>
                        If you have any questions or encounter issues, consider reaching out
                        to the Supchain community on Discord or Telegram for additional
                        information and assistance from moderators.
                      </li>
                    </ul>
                  </div>
                </div>`,
          image: twallet5
        },
      ]
  
    },
    {
      name: "Don't have a wallet?",
      heading: "BUY SUPC USING IT IF YOU HAVE NO WALLET.",
      subheading: "Metamask is the leading self-custodial wallet. The safe and simple way to access blockchain applications and web3.",
      image: noWalletBg,
      topics: [
        {
          topic: "HOW TO CREATE A WALLET - Supchain",
          content: `<div style="list-style: inside">
                  <h5>Creating a Wallet with Metamask:</h5>
                  <div>
                    <p><b>Step 1: Install the Metamask Extension:</b></p>
                    <ul>
                      <li>
                        Open your web browser (Google Chrome or Mozilla Firefox is
                        recommended).
                      </li>
                      <li>Go to the Metamask website.</li>
                      <li>
                        Click on the "Download" button to install the Metamask extension.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 2: Add Metamask to Your Browser: </b></p>
                    <ul>
                      <li>
                        Follow the installation instructions for your specific browser.
                      </li>
                      <li>
                        After installation, you will see the Metamask icon (a colorful fox
                        face) in your browser's extensions or add-ons area.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Launch Metamask: </b></p>
                    <ul>
                      <li>
                        Click on the Metamask icon in your browser to launch the extension.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 3: Launch Metamask: </b></p>
                    <ul>
                      <li>
                        Click on the Metamask icon in your browser to launch the extension.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 5: Create a New Wallet:</b></p>
                    <ul>
                      <li>Click on "Create a Wallet."</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 6: Terms of Use:</b></p>
                    <ul>
                      <li>Review and accept the Terms of Use and Privacy Notice.</li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 7: Create a Strong Password:</b></p>
                    <ul>
                      <li>
                        Enter a strong password for your Metamask wallet. Make sure it's
                        unique and difficult to guess.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 8: Back Up Your Seed Phrase:</b></p>
                    <ul>
                      <li>
                        Metamask will generate a unique 12 or 24-word seed phrase. Write
                        this phrase down on a piece of paper and store it in a safe place.
                        This phrase is crucial for wallet recovery and should never be
                        shared with anyone.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 9: Confirm Your Seed Phrase: </b></p>
                    <ul>
                      <li>
                        After writing down the seed phrase, Metamask will ask you to confirm
                        it by selecting the words in the correct order. This ensures you've
                        recorded the phrase correctly.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 10: Wallet Created: </b></p>
                    <ul>
                      <li>
                        Congratulations! Your Metamask wallet is now created. You can start
                        using it to store, send, and receive cryptocurrencies.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 11: Secure Your Wallet:</b></p>
                    <ul>
                      <li>
                        It's essential to keep your wallet and seed phrase secure. Never
                        share your seed phrase with anyone and consider using a hardware
                        wallet for added security.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Step 12: Connect Your Wallet:</b></p>
                    <ul>
                      <li>
                        If you intend to use your Metamask wallet on websites like Supchain,
                        you can connect it by clicking the Metamask icon and selecting your
                        wallet.
                      </li>
                    </ul>
                  </div>
            
                  <p>
                    That's it! You've successfully created a wallet using the Metamask
                    extension. Ensure you keep your seed phrase safe and never share it with
                    anyone to protect your cryptocurrency assets.
                  </p>
                </div>`,
          image: nowallet1
        },
        {
          topic: "PC & Laptop Users",
          content: ` <div style="list-style: inside">
                  <div>
                    <p><b>Get the MetaMask browser extension</b></p>
                    <ul>
                      <li>
                        MetaMask is a self-custody wallet that only you control. Visit the
                        ​MetaMask website and install the extension for your preferred
                        browser. The most common are Chrome and Firefox.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Create your new wallet</b></p>
                    <ul>
                      <li>
                        After installing MetaMask, click on ‘Create a Wallet’. Your wallet is
                        a public key comprising randomly generated numbers and letters. This
                        is your identifier on the blockchain, like a bank account number for
                        your crypto.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Set a password for your wallet</b></p>
                    <ul>
                      <li>
                        Next, create a password to log in to your wallet. Choose a secure
                        password with letters, numbers, and special characters. Try to use a
                        different password to your others.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Save and write down recovery phrase</b></p>
                    <ul>
                      <li>
                        Before you do anything else, write down your 12-word recovery phrase
                        on a piece of paper and keep it in the safest place possible. Don’t
                        store it on the same device you use to access your wallet! You’ll
                        need this recovery phrase if you ever lose access to your wallet.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Use the Ethereum or BNB Chain network </b></p>
                    <ul>
                      <li>
                        By default, MetaMask is set to transact on the Ethereum network. You
                        can purchase Wall Street Memes (SUPC) using ETH as soon as you buy or
                        send some ETH to your MetaMask public address. ETH is needed to pay
                        for gas fees for every transaction.
                      </li>
                      <li>
                        If you wish to buy SUPC tokens using BNB, read this guide on how to
                        add the BNB Chain network to your MetaMask wallet. BNB serves the
                        same purpose as ETH and is needed to pay for gas on BNB Chain.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Claiming your SUPC tokens</b></p>
                    <ul>
                      <li>
                        After buying SUPC tokens, you can see how much you’ll be able to
                        claim on the website’s home page. After the presale, once claiming
                        is activated, you’ll be able to claim your SUPL tokens to the same
                        MetaMask wallet address you used to contribute.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Import SUPC to MetaMask</b></p>
                    <ul>
                      <li>
                        After buying SUPC tokens, you can see how much you’ll be able to claim on the website’s home page. After the presale, once claiming is activated, you’ll be able to claim your SUPC  tokens to the same MetaMask wallet address you used to contribute.
                      </li>
                    </ul>
                  </div>
                </div>`,
          image: nowallet2
        },
        {
          topic: "Phone & Tablet",
          content: `   <div style="list-style: inside">
                  <div>
                    <p><b>Get the Trust Wallet app</b></p>
                    <ul>
                      <li>
                        There are many mobile wallets out there, but Trust Wallet is widely recommended. Download the app from your preferred app store, depending on your mobile device.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Start a new wallet.</b></p>
                    <ul>
                      <li>
                        Click on the ‘Create a Wallet’ button to start a new wallet that you can use on your mobile phone. Set a new password if prompted to do so.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Save your passphrase</b></p>
                    <ul>
                      <li>
                        This step is very important! Write down your 12-word backup passphrase. Then manually type the 12 words in the correct sequence. You’ll need this passphrase to regain access to your wallet on a different device should you ever lose access.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Use Ethereum or BNB Chain</b></p>
                    <ul>
                      <li>
                        Trust Wallet supports transactions on Ethereum or BNB Chain. You can purchase Wall Street Memes (SUPC) using ETH or BNB as soon as you buy or send some ETH or BNB to your Trust Wallet address. ETH or BNB is needed to pay gas fees for every transaction.
                      </li>
                    </ul>
                  </div>
            
                  <div>
                    <p><b>Claiming your SUPC tokens</b></p>
                    <ul>
                      <li>
                        After buying SUPC tokens, you can see how much you’ll be able to
                        claim on the website’s home page. After the presale, once claiming
                        is activated, you’ll be able to claim your SUP tokens to the same
                        MetaMask wallet address you used to contribute.
                      </li>
                    </ul>
                  </div>
            
            
                </div>`,
          image: nowallet3
        },
        {
          topic: "Add SUPL to Trust Wallet",
          content: ` <div style="list-style: inside">
                  <div>
                    <ul>
                      <li>
                        To view your token balance within Trust Wallet, add the SUPC token to your wallet. Click on the dotted button in the top-right of the screen, followed by ‘Add Custom Token.’ Paste the SUPC contract address:
                      </li>
                    </ul>
                  </div>
                </div>`,
          image: nowallet4
        },
      ]
  
    },
  
  ]
  